import { GetServerSideProps } from 'next'
import Head from 'next/head'
import Script from 'next/script'
import { useTranslation } from 'hooks/useTranslation'
import { PostsList } from 'features/Blog/screens/PostsList'
import { FeedArticle } from 'features/Blog/utils/parseFeed'
import { SearchableArticle } from 'features/Blog/utils/getBlogIndexPageProps'
import { getBlogIndexServerSideProps } from 'features/Blog/utils/getBlogIndexServerSideProps'
import { getBlogIndexSchema } from 'features/Blog/utils/getBlogIndexSchema'
import { pageHref } from 'features/Blog/utils/pageHref'

type BlogPostsProps = {
  articles: FeedArticle[]
  page: number
  totalPages: number
  searchableArticles: SearchableArticle[]
  activeTags: string[]
}

const BlogPosts = (props: BlogPostsProps) => {
  const { t } = useTranslation()

  const jsonLdString = JSON.stringify(getBlogIndexSchema(props.page))

  return (
    <div>
      <Head>
        <title>{t('blog:page-title')}</title>
        <meta name="title" content={t('blog:meta-title')} />
        <meta name="description" content={t('blog:meta-description')} />
        <link rel="canonical" href={`https://wefeedraw.com${pageHref(props.page, props.activeTags)}`} />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://www.googletagmanager.com" />
        <link rel="preconnect" href="https://googleads.g.doubleclick.net" />
      </Head>

      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />
      <PostsList {...props} />
    </div>
  )
}

export const getServerSideProps: GetServerSideProps = async (ctx) => getBlogIndexServerSideProps(ctx, 1)

export default BlogPosts
